import StyledButton from "components/shared/StyledButton";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "store/store";

/**
 * The style of this component will be changed as a list when we'll have futher integrations possibility
 */
interface IIntegrationElement {
    integrationName: string;
    logo: React.ReactNode;
    btnTxt: string;
    /**
     * Action on submit connect integration btn
     */
    onConnect: () => void;
}
const IntegrationElement = ({ integrationName, logo, btnTxt, onConnect }: IIntegrationElement) => {
    const [t] = useTranslation();
    const authGoogleStatus = useAppSelector((state) => state.integrations.authGoogleStatus);
    const integrationCode = integrationName.toLowerCase();

    const isLoading = {
        google: authGoogleStatus === "pending",
    };

    return (
        <div className="integration-modal-element">
            <div className="integration-modal-element-top">
                {logo}
                <span className="connect-title">{integrationName}</span>
            </div>
            <span className="connect-subtitle">{t("IntegrationsSettings.GoogleSubtitle")}</span>
            <StyledButton
                buttonType="primary"
                fullWidth
                onClick={onConnect}
                loading={isLoading[integrationCode]}
                disabled={isLoading[integrationCode]}
            >
                {!isLoading[integrationCode] && btnTxt}
            </StyledButton>
        </div>
    );
};

export default IntegrationElement;
